import { useMemo } from 'react'

import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell'
import { SCHEDULING_ROUTING_FORMS_TAB_BASE } from 'hooks/home/tabs'

const LEGACY_ROUTING_FORMS_BASE = '/app/routing/forms'

const ROUTING_FORMS_LIST_PATH_PREFIXES = ['/app/routing/forms', '/app/scheduling/routing/forms']

/**
 * Path segments that only appear on non-list flows under …/forms/… (edit surface, responses, future deep routes).
 * Keep in sync with the `Switch` in `routing.js` (any route more specific than the list `Route` should add a marker here).
 */
const ROUTING_FORMS_DEEP_WORKFLOW_SEGMENTS = new Set(['edit', 'responses'])

/**
 * True when pathname is the routing forms list (scoped index), not wizard or other deep flows under …/forms/.
 * Used by publisher redirects and scheduling tab content guards.
 */
export const isRoutingFormsListPathname = (pathname) => {
  const raw = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '')
  const p = raw.split('?')[0]
  const prefix = ROUTING_FORMS_LIST_PATH_PREFIXES.find((pre) => p === pre || p.startsWith(`${pre}/`))
  if (!prefix) return false

  const rest = p.slice(prefix.length).replace(/^\//, '')
  if (rest === '') return true

  const segments = rest.split('/').filter(Boolean)
  if (segments.length === 0) return true

  if (segments[0] === 'new') return false
  if (segments.some((segment) => ROUTING_FORMS_DEEP_WORKFLOW_SEGMENTS.has(segment))) return false

  return true
}

/** List URL base for policy redirects and “back to forms” when embedded list lives under Scheduling (refresh). */
export const useRoutingFormsBase = () => {
  const isProductRefreshAppShell = useProductRefreshAppShell()
  return useMemo(
    () => (isProductRefreshAppShell ? SCHEDULING_ROUTING_FORMS_TAB_BASE : LEGACY_ROUTING_FORMS_BASE),
    [isProductRefreshAppShell]
  )
}

export const newFormUrl = (step) => `${LEGACY_ROUTING_FORMS_BASE}/new/${step}`

export const editFormUrl = (id, step = 'fields') => `${LEGACY_ROUTING_FORMS_BASE}/${id}/edit/${step}`

export const formResponsesUrl = (id) => `${LEGACY_ROUTING_FORMS_BASE}/${id}/responses`
